import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"content-header\"><div class=\"container-fluid\"><div class=\"row mb-2\"><div class=\"col-sm-6\"><h1>Contatos</h1></div><div class=\"col-sm-6\"><ol class=\"breadcrumb float-sm-right\"><li class=\"breadcrumb-item\"><a href=\"#\">Home</a></li><li class=\"breadcrumb-item active\">Contatos</li></ol></div></div></div></section>", 1)
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "card-tools" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "card-body row" }
const _hoisted_11 = { class: "form-group col-12 col-md-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "contact_type" }, [
  /*#__PURE__*/_createTextVNode("Tipo "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "form-group col-12 col-md-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "enabled" }, "Situação", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "form-group col-12 col-md-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, [
  /*#__PURE__*/_createTextVNode("Nome "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_19 = { class: "form-group col-12 col-md-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, [
  /*#__PURE__*/_createTextVNode("E-mail "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_21 = { class: "form-group col-12 col-md-6" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "phone1" }, "Telefone 1", -1)
const _hoisted_23 = { class: "form-group col-12 col-md-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "phone2" }, "Telefone 2", -1)
const _hoisted_25 = { class: "form-group col-12 col-md-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "authorization_email" }, "Autoriza envio de e-mail", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = { class: "form-group col-12 col-md-6" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { for: "authorization_sms" }, "Autoriza envio de SMS", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = { class: "form-group col-12 col-md-6" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { for: "authorization_whatsapp" }, "Autoriza envio de Whatsapp", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = { class: "form-group col-12" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Observações", -1)
const _hoisted_36 = { class: "card-footer text-center" }
const _hoisted_37 = { class: "btn-group" }

export function render(_ctx, _cache) {
  const _component_Toggle = _resolveComponent("Toggle")
  const _directive_maska = _resolveDirective("maska")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, "Contato | " + _toDisplayString(_ctx.id), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-tool",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.goBack())),
                title: "Voltar"
              }, _hoisted_9)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("div", { class: "col-12 alert alert-danger" }, _toDisplayString(_ctx.errorMessage), 513), [
              [_vShow, _ctx.errorMessage != '']
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("select", {
                id: "contact_type",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.row.contact_type) = $event)),
                style: {"width":"auto","max-width":"-webkit-fill-available"},
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.contact_type }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactTypes, (i, k) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: i.id,
                    key: k
                  }, _toDisplayString(i.description), 9, _hoisted_13))
                }), 128))
              ], 2), [
                [_vModelSelect, _ctx.row.contact_type]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.contact_type), 513), [
                [_vShow, _ctx.errors.contact_type != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _hoisted_16,
              _createVNode(_component_Toggle, {
                modelValue: _ctx.row.enabled,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.row.enabled) = $event)),
                "on-label": "Ativo",
                "off-label": "Inativo",
                class: "toggle-enabled"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                id: "name",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.row.name) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.name }]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.name]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.name), 513), [
                [_vShow, _ctx.errors.name != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _withDirectives(_createElementVNode("input", {
                id: "email",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.row.email) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.email }]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.email]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.email), 513), [
                [_vShow, _ctx.errors.email != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _withDirectives(_createElementVNode("input", {
                id: "phone1",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.row.phone1) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.phone1 }]),
                style: {"max-width":"200px"},
                maxlength: "15"
              }, null, 2), [
                [_vModelText, _ctx.row.phone1],
                [_directive_maska, ['(##) ####-####', '(##) # ####-####']]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.phone1), 513), [
                [_vShow, _ctx.errors.phone1 != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _withDirectives(_createElementVNode("input", {
                id: "phone2",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.row.phone2) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.phone2 }]),
                style: {"max-width":"200px"},
                maxlength: "15"
              }, null, 2), [
                [_vModelText, _ctx.row.phone2],
                [_directive_maska, ['(##) ####-####', '(##) # ####-####']]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.phone2), 513), [
                [_vShow, _ctx.errors.phone2 != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _hoisted_27,
              _createVNode(_component_Toggle, {
                modelValue: _ctx.row.authorization_email,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.row.authorization_email) = $event)),
                "on-label": "Sim",
                "off-label": "Não"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _hoisted_30,
              _createVNode(_component_Toggle, {
                modelValue: _ctx.row.authorization_sms,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.row.authorization_sms) = $event)),
                "on-label": "Sim",
                "off-label": "Não"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _hoisted_33,
              _createVNode(_component_Toggle, {
                modelValue: _ctx.row.authorization_whatsapp,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.row.authorization_whatsapp) = $event)),
                "on-label": "Sim",
                "off-label": "Não"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _withDirectives(_createElementVNode("textarea", {
                id: "description",
                rows: "4",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.row.description) = $event)),
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.description }])
              }, null, 2), [
                [_vModelText, _ctx.row.description]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.description), 513), [
                [_vShow, _ctx.errors.description != null]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("button", {
                type: "button",
                id: "cancelButton",
                class: "btn btn-warning",
                onClick: _cache[11] || (_cache[11] = $event => (_ctx.goBack()))
              }, "Cancelar"),
              _createElementVNode("button", {
                type: "button",
                id: "gravarButton",
                class: "btn btn-success",
                onClick: _cache[12] || (_cache[12] = $event => (_ctx.save()))
              }, "Gravar")
            ])
          ])
        ])
      ])
    ])
  ], 64))
}